// @owners { team: patients }
import { useEffect, useRef } from 'react';
import { setHasChangedDeliveryMethod } from '~shared/actions/ui/progynyWizard';
import { useCartDeliveryMethods } from '~shared/features/cart/queries/useCartDeliveryMethods';
import { isMail } from '~shared/helpers/order';
import { useDispatchShared } from '~shared/store';

// Tracks delivery method changes so scheduled_with_progyny_wizard resets if the patient's address change switches courier ↔ mail.
export const useTrackDeliveryMethodChange = () => {
  const dispatch = useDispatchShared();
  const { deliveryMethods } = useCartDeliveryMethods();
  const isShippedByMail = deliveryMethods.some((method) => isMail(method.mode));
  const hasData = deliveryMethods.length > 0;
  const originalShippedByMail = useRef<boolean | null>(null);

  useEffect(() => {
    if (!hasData) return;
    if (originalShippedByMail.current === null) {
      originalShippedByMail.current = isShippedByMail;
    }
    dispatch(
      setHasChangedDeliveryMethod({ hasChangedDeliveryMethod: originalShippedByMail.current !== isShippedByMail }),
    );
  }, [dispatch, hasData, isShippedByMail]);
};
